import { styled } from '../../Utilities';
import { DocumentCardActionsBase } from './DocumentCardActions.base';
import { getStyles } from './DocumentCardActions.styles';
export var DocumentCardActions = styled(DocumentCardActionsBase, getStyles, undefined, {
  scope: 'DocumentCardActions'
});